const __DEV__ = window.location.pathname.indexOf("/dora/") > -1
  || window.location.hostname === "localhost"
const __TEST__ = window.location.pathname.indexOf("/dora-test/") > -1

export {
  __DEV__,
  __TEST__
}
